<template>
  <div class="agent-dashboard">
    <!-- 数据查询条件 -->
    <div class="section">
      <div class="section-title">{{ $t('proxy.text200') }}</div>
      <div class="section-content mt-20">
        <el-button
          :class="{'active-btn': activeButton === 'my', 'inactive-btn': activeButton !== 'my'}"
          @click="fetchDashboardData('my')"
        >
          {{$t('proxy.text6')}}
        </el-button>
        <el-button
          v-if="hasSubProxyDataPermission"
          :class="{'active-btn': activeButton === 'agent', 'inactive-btn': activeButton !== 'agent'}"
          class="ml-20"
          @click="fetchDashboardData('agent')"
        >
          {{$t('proxy.text7')}}
        </el-button>
        <div class="search-row">
          <span style="width: 320px; ">
            {{ $t('proxy.text287') + '：'}}
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              :start-placeholder="$t('proxy.text201')"
              :end-placeholder="$t('proxy.text202')"
              format="MM/DD/YYYY"
              value-format="YYYY-MM-DD"
            />
          </span>
          <el-form-item v-if="activeButton === 'agent'" :label="$t('proxy.text301') + '：'" class="search-label">
            <el-select clearable v-model="searchForm.SProxyId" placeholder="" class="custom-select">
              <el-option
                v-for="agent in formattedAgents"
                :key="agent.proxyId"
                :label="agent.indentedName"
                :value="agent.proxyId"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-button class="ml-10" type="primary" @click="fetchDashboardDataBySearch">
          {{$t('proxy.text13')}}
        </el-button>
      </div>
    </div>

    <!-- 数据总览 -->
    <div class="section">
      <div class="section-title">{{$t('proxy.text14')}}</div>
      <div class="section-content mt-30">
        <div class="data-summary">
          <div class="data-card">
            <div class="data-value">{{ dashboardData.proxyNum }}</div>
            <div class="data-label">{{$t('proxy.text15')}}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.regiserUser }}</div>
            <div class="data-label">{{$t('proxy.text16')}}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.openAccountUser }}</div>
            <div class="data-label">{{$t('proxy.text17')}}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.tradeNum || '0' }}</div>
            <div class="data-label">{{$t('proxy.text19')}}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.payCommission || '0.00' }}</div>
            <div class="data-label">{{ $t('proxy.text203') }}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.canUseTradeFee || '0.00' }}</div>
            <div class="data-label">{{ $t('proxy.text204') }}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.inMoney || '0.00'}}</div>
            <div class="data-label">{{$t('proxy.text22')}}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.outMoney || '0.00' }}</div>
            <div class="data-label">{{$t('proxy.text23')}}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.netInMoney || '0.00' }}</div>
            <div class="data-label">{{ $t('proxy.text205') }}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ dashboardData.tradeFeeCommission || '0.00' }}</div>
            <div class="data-label">{{ $t('proxy.text310') + '（USD）' }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 净值总览 -->
    <div class="section">
      <div class="section-title">
        {{ $t('proxy.text302') }}
        <div class="filter-wrapper">
          <el-select style="width: 160px; " v-model="netValueFilter" placeholder="">
            <el-option :label="$t('proxy.text95')" value="all"></el-option>
            <el-option label="Web" value="web"></el-option>
            <el-option label="MT4" value="mt4"></el-option>
          </el-select>
        </div>
      </div>
      <div class="section-content mt-30">
        <div class="data-summary">
          <div class="data-card">
            <div class="data-value">{{ report.netValueStart }}</div>
            <div class="data-label">{{ $t('proxy.text206') }}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ report.netValueFollowStart }}</div>
            <div class="data-label">{{ $t('proxy.text207') }}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ report.netValue }}</div>
            <div class="data-label">{{ $t('proxy.text208') }}</div>
          </div>
          <div class="data-card">
            <div class="data-value">{{ report.netValueFollow }}</div>
            <div class="data-label">{{ $t('proxy.text209') }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 趋势分析 -->
    <div class="section">
      <div class="section-title">{{ $t('proxy.text210') }}</div>
      <div class="section-content">
        <canvas id="myChart" ref="chart" width="400" height="100"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '@/api/request'; // 假设你的 API 请求文件在此路径
import {
  ElButton,
  ElDatePicker,
  ElSelect,
  ElOption,
  ElMessage
} from 'element-plus';
import Chart from 'chart.js/auto';
import { ref, onMounted, watch, reactive } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  setup() {
    const { t } = useI18n();
    const chartInstance = ref(null);
    const formattedAgents = ref([]);
    const activeButton = ref('my'); // 初始值为我的客户
    const dateRange = ref('');
    const searchForm = reactive({
      SProxyId: null,
    });
    const dashboardData = reactive({
      proxyNum: 0,
      regUser: 0,
      openAccountUser: 0,
      tradeNum: 0,
      payCommission: 0,
      canUseTradeFee: 0,
      inMoney: 0,
      outMoney: 0,
      netInMoney: 0,
    });
    const report = reactive({
      netValue: 0,
      netValueStart: 0,
      netValueFollow: 0,
      netValueFollowStart: 0,
    });
    const netValueFilter = ref('all'); // 初始值设为 'all'
    const dayCommission = ref([]);
    const hasSubProxyDataPermission = ref(false); // 是否可以查看子代理数据

    // 获取用户信息，判断是否查看子代理数据
    const fetchUserInformation = async () => {
      try {
        const response = await apiService.UserInformation();  // 请求接口获取用户信息
        if (response.status === 1) {
          hasSubProxyDataPermission.value = response.data.hasSubProxyDataPermission;
        } else {
          ElMessage.error(response.message);  // 处理接口失败
        }
      } catch (error) {
        ElMessage.error('获取用户信息失败');
        console.error(error);
      }
    };


    const fetchAgents = async () => {
      try {
        const response = await apiService.proxyAllSubProxyList();
        if (response.status === 1 && response.data.proxyTree) {
          formattedAgents.value = formatAgents(response.data.proxyTree);
        } else {
          console.error('代理列表获取失败:', response.message || '未知错误');
        }
      } catch (error) {
        console.error('获取代理列表失败:', error);
      }
    };

    const formatAgents = (agentsList, level = 0) => {
      return agentsList.flatMap((agent) => {
        const indentedAgent = {
          proxyId: agent.proxyId,
          indentedName: `${'ㅤ'.repeat(level)}${agent.proxyName}`,
        };
        const children = agent.childProxyInfo
          ? formatAgents(agent.childProxyInfo, level + 1)
          : [];
        return [indentedAgent, ...children];
      });
    };

    const fetchDashboardDataBySearch = () => {
      fetchDashboardData(activeButton.value);
    };

    const fetchDashboardData = async (type = 'my') => {
      activeButton.value = type; // 更新当前选中的按钮
      const isSub = type === 'agent'; // 如果选中的是代理客户，isSub为true
      const params = {
        StartDate: dateRange.value ? dateRange.value[0] : null,
        EndDate: dateRange.value ? dateRange.value[1] : null,
        isSub, // 传递isSub值
      };
      if (isSub && searchForm.SProxyId) {
        params.SProxyId = searchForm.SProxyId;
      }
      try {
        const response = await apiService.proxyDashboard(params);
        const data = response.data;

        if (netValueFilter.value === 'all') {
          Object.assign(report, data.report);
        } else if (netValueFilter.value === 'web') {
          Object.assign(report, data.webreport);
        } else if (netValueFilter.value === 'mt4') {
          Object.assign(report, data.mt4report);
        }
        Object.assign(dashboardData, data.dashBoard);
        dayCommission.value = data.dayCommission || [];
        updateChart();
      } catch (error) {
        console.error('API请求错误:', error);
      }
    };

    const updateChart = () => {
      const labels = dayCommission.value.map((item) => item.curDate);
      const commissionData = dayCommission.value.map((item) => item.commission)
      const tradeFeeCommission = dayCommission.value.map((item) => item.tradeFeeCommission);
      const totalCommission = dayCommission.value.map((item) => item.totalCommission);
      
      if (chartInstance.value) {
        chartInstance.value.destroy();
        chartInstance.value = null;
      }

      if (!chartInstance.value) {
        const ctx = document.getElementById('myChart').getContext('2d');
        chartInstance.value = new Chart(ctx, {
          type: 'line',
          data: {
            labels,
            datasets: [
              {
                label: t('proxy.text309'),
                data: totalCommission,
                fill: false,
                borderColor: '#0D9172',
                tension: 0.2,
              },
              {
                label: t('trade.text78'),
                data: commissionData,
                fill: false,
                borderColor: '#51B4F1',
                tension: 0.2,
              },
              {
                label: t('proxy.text307'),
                data: tradeFeeCommission,
                fill: false,
                borderColor: '#FB741B',
                tension: 0.2,
              },
           
            ],
          },
          options: {
            plugins: {
              legend: {
                labels: {
                  usePointStyle: true,
                  pointStyle: 'line',
                  color: '#666D7F',
                },
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                },
                border: {
                  display: false,
                },
              },
              y: {
                grid: {
                  color: '#F2F4FB',
                },
                border: {
                  display: false,
                },
              },
            },
          },
        });
      } else {
        chartInstance.value.data.labels = labels;
        chartInstance.value.data.datasets[0].data = commissionData;
        chartInstance.value.update(); // 更新图表
      }
    };

    watch(netValueFilter, () => {
      fetchDashboardData(activeButton.value);
    });

    onMounted(() => {
      fetchUserInformation();
      fetchDashboardData();
      fetchAgents(); // 获取代理列表
    });

    return {
      t,
      chartInstance,
      activeButton,
      dateRange,
      searchForm,
      formattedAgents,
      dashboardData,
      report,
      netValueFilter,
      dayCommission,
      fetchDashboardDataBySearch,
      fetchDashboardData,
      updateChart,
      hasSubProxyDataPermission,
    };
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
  },
  components: {
    ElButton,
    ElDatePicker,
    ElSelect,
    ElOption,
  },
};
</script>

<style scoped>
.section-content {
  display: flex;
  justify-content: start;
  align-items: center;
}

.search-row {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.search-row > span {
  white-space: nowrap; /* 禁止换行 */
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.search-row .search-label {
  margin-right: 40px;
  display: flex;
  align-items: center;
}

.search-label {
  margin: 0;
}

.custom-select {
  width: 160px;
}

.data-summary {
  display: flex;
  flex-wrap: wrap;
  max-width: 1140px;
}
.data-card {
  background: rgba(81, 180, 241, 0.08);
  border-radius: 8px;
  margin-right: 20px;
  margin-bottom: 20px;
  text-align: center;
  width: 170px;
  padding: 16px 0;
}
.data-value {
  font-weight: bolder;
  font-size: 20px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 4px;
}
.data-label {
  font-size: 14px;
  color: #666d7f;
  line-height: 20px;
}
.section-title {
  position: relative;
}
.filter-wrapper {
  position: absolute;
  right: 128px;
}
.active-btn {
  background-color: #51B4F1;
  color: white;
  border-color: #51B4F1;
}
.inactive-btn {
  background-color: white;
  color: #666;
  border-color: #dcdfe6;
}
</style>
